<div class="createFormContainer blockCreateForm">

  <div class="createFormHeader">
    <div class="formCapContainer">
      <div class="formCapItem formTitle">
        <span class="blockNavigationContainer">
          <span>
            {{ t_formTitle }}
          </span>
        </span>
      </div>
        <div class="buttonGroup buttonGroup-endPosition">
          <button class="plainButton closeButton tooltipParent"
            (click)="closeForm()">
            <fa-icon [icon]="iconTimesCircle"></fa-icon>
            {{ t_close }}
            <div class="tooltip">{{ t_close }}</div>
          </button>
        </div>
    </div>
    <div class="fieldContainer">
      <div class="blockSearchContainer">
        <div class="blockSearchField">
            <input class="textInput"
                [ngModel]="inEditionData.title"
                #freeTextInput
                [focusIf]="true"
                name="title"
                type="text"
                placeholder="{{t_titleInputPlaceholder}}">
        </div>
        <div class="buttonGroup buttonGroup-endPosition">
          <button class="plainButton"
              (click)="submitForm()">
            <fa-icon [icon]="iconPlus"></fa-icon>
              {{ t_createActionLabel }}
          </button>
        </div>
      </div>
    </div>
  </div>
 <!-- BLOCK MAIN AREA -->
  </div>  <!-- END OF BLOCK MAIN AREA -->
